// extracted by mini-css-extract-plugin
export default {"aboutContainer":"aboutUs_aboutContainer__mcGAV","aboutTitle":"aboutUs_aboutTitle__RIxsT","descriptions":"aboutUs_descriptions__dtF1M"};